function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["getPrice"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var generateUUID = function generateUUID() {
  // Public Domain/MIT
  var d = new Date().getTime();
  if (typeof performance !== "undefined" && typeof performance.now === "function") {
    d += performance.now(); //use high-precision timer if available
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === "x" ? r : r & 0x3 | 0x8).toString(16);
  });
};
var isNumeric = function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};
var isProduct = function isProduct(product) {
  return product.upc !== undefined;
};
var objectPath = function objectPath(nestedObj, pathStr) {
  return pathStr.split(".").reduce(function (obj, key) {
    return obj && obj[key] !== undefined ? obj[key] : undefined;
  }, nestedObj);
};
var removeGetPriceFromFeebusterPTF = function removeGetPriceFromFeebusterPTF() {
  var ptfs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return ptfs.map(function (ptf) {
    if (ptf.name !== "feebuster") {
      return ptf;
    }
    if (ptf.extra && ptf.extra.cashPrice) {
      var _ptf$extra$cashPrice = ptf.extra.cashPrice,
        getPrice = _ptf$extra$cashPrice.getPrice,
        restOfCashPrice = _objectWithoutProperties(_ptf$extra$cashPrice, _excluded);
      return _objectSpread(_objectSpread({}, ptf), {}, {
        extra: _objectSpread(_objectSpread({}, ptf.extra), {}, {
          cashPrice: restOfCashPrice
        })
      });
    }
    return ptf;
  });
};
var round = function round(x) {
  return Math.round((Math.sign(x) * x).toFixed(4)) * Math.sign(x);
};
module.exports = {
  generateUUID: generateUUID,
  isNumeric: isNumeric,
  isProduct: isProduct,
  objectPath: objectPath,
  removeGetPriceFromFeebusterPTF: removeGetPriceFromFeebusterPTF,
  round: round
};